module.exports = {
  "country": "AT",
  "artist": "Udo Jürgens",
  "song": "Merci, Chérie",
  "year": "1966",
  "place": "1",
  "spotify": "76F9Vq9AZjeqx6015lcZ3D"
};